/**
 * Smartly reads value from localStorage
 */
export const LOCAL_STORAGE_CHANGE_EVENT = 'app-local-storage-change';

function notifyLocalStorageChange(name: string) {
  window.dispatchEvent(
    new CustomEvent(LOCAL_STORAGE_CHANGE_EVENT, {
      detail: { key: name },
    })
  );
}

export function localStorageGet(name: string, defaultValue = '') {
  const valueFromStore = localStorage.getItem(name);
  if (valueFromStore === null) return defaultValue; // No value in store, return default one

  try {
    let jsonParsed: any;
    try {
      jsonParsed = JSON.parse(valueFromStore);
    } catch (error) {
      jsonParsed = valueFromStore;
    }
    if (
      ['boolean', 'number', 'bigint', 'string', 'object'].includes(
        typeof jsonParsed
      )
    ) {
      return jsonParsed; // We successfully parse JS value from the store
    }
  } catch (error) {
    console.error('Error parsing localStorage value', error);
  }

  // console.log(`localStorageGet(${name}) - result:`, valueFromStore)
  return valueFromStore; // Return string value as it is
}

/**
 * Smartly writes value into localStorage
 */
export function localStorageSet(name: string, value: any) {
  if (typeof value === 'undefined') {
    return; // Do not store undefined values
  }
  let valueAsString;
  if (typeof value === 'object') {
    valueAsString = JSON.stringify(value);
  } else {
    valueAsString = String(value);
  }

  localStorage.setItem(name, valueAsString);
  notifyLocalStorageChange(name);
}

/**
 * Deletes value by name from localStorage, if specified name is empty the localStorage is cleared.
 */
export function localStorageDelete(name: string) {
  if (name) {
    localStorage.removeItem(name);
    notifyLocalStorageChange(name);
  } else {
    localStorage.clear();
    notifyLocalStorageChange('*');
  }
}
